import Event from './Event';

export enum NotificationType {
    Error,
    Info
}

interface NotificationConfig {
    message?: string;
    notificationType?: NotificationType;
    event?: Event;
    hasButton?: boolean;
    preventDuplicates?: boolean;
}

export default class Notification {
    constructor(public readonly id: string, public readonly data: NotificationConfig) {}
}



// WEBPACK FOOTER //
// ./src/application/core/Notification.ts